import React, { useState } from 'react';
import { Button, CircularProgress } from '@mui/material';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import { useNavigate } from 'react-router-dom';
import server from '../global/server';
import useHandleErrors from '../hooks/useHandleErrors';

/**
 * Porta de entrada do canal interno (Termos 1.11).
 *
 * A conversa nasce do pedido, e não do par de pessoas: o endpoint abre a que
 * faltar e devolve a que já existir, então clicar duas vezes leva sempre à
 * mesma conversa. Criar só no clique evita encher o banco de conversa vazia —
 * a maioria dos encontros acontece sem ninguém precisar escrever nada.
 */
const BotaoConversar = ({ orderId, label = 'Conversar', sx, ...props }) => {
    const navigation = useNavigate();
    const [abrindo, setAbrindo] = useState(false);
    const [erro, setErro] = useState();
    useHandleErrors(erro);

    const abrir = async () => {
        if (!orderId || abrindo) return;

        try {
            setAbrindo(true);
            const { data } = await server.post(`/conversas/pedido/${orderId}`);
            navigation(`/conversas/${data.data.id}`);
        } catch (falha) {
            setErro(falha);
            setAbrindo(false);
        }
    };

    return (
        <Button
            variant="outlined"
            size="small"
            onClick={abrir}
            disabled={abrindo}
            startIcon={abrindo ? <CircularProgress size={14} /> : <ChatBubbleOutlineIcon />}
            {...props}
            sx={{ textTransform: 'none', borderRadius: '8px', ...sx }}>
            {label}
        </Button>
    );
};

export default BotaoConversar;
